<template>
    <div class="progress-bar">
        <div class="steps">
            <div class="step" v-for="(step, index) in steps" v-bind:class="[
            `step-${step.step}`,
            index === 0 ? 'first' : '',
            index === steps.length - 1 ? 'last' : '',
            step.active ? 'active' : 'inactive',
            step.completed ? 'completed' : '',
            ]">
                <span class="step-details">
                    <span class="number">
                        {{step.completed ? '✓' : step.step}}
                    </span>
                    <a v-bind:href="step.completed ? step.href : '#'" class="name">
                        <span>
                            {{step.name}}
                        </span>
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    $stepIconSize: 2em;
    $innerPadding: 0.25em;

    $yellow: #ffcf00;
    $grey: #cecece;

    .progress-bar {
        width: 100%;
        max-width: 800px;

        margin: 0 auto;

        .steps {

            display: flex;
            text-align: center;
            font-size: 0.75em;
            flex-direction: column;
            justify-content: center;

            @media (min-width: 768px) {
                flex-direction: row;
            }

            .step {
                margin: 2em auto 0;
                width: 100%;
                max-width: 300px;
                position: relative;

                &.first {
                    margin-top: 0;
                }

                @media (min-width: 768px) {
                    margin-top: 0;
                }

                &:after {
                    $thickness: 3px;
                    background: $grey;
                    content: '';
                    display: block;
                    position: absolute;
                    width: $thickness;
                    height: 120%;

                    top: 100%;
                    left: 50%;
                    transform: translate(-50%, $innerPadding * -8);
                    z-index: -1;

                    @media (min-width: 768px) {
                        height: $thickness;
                        width: 100%;

                        top: $stepIconSize / 2;

                        transform: translate(0, -50%);
                    }
                }

                &.last {
                    &:after {
                        display: none;
                    }
                }

                .step-details {
                    display: flex;
                    flex-direction: column;

                    > * {
                        margin: 0 auto;
                        border: $innerPadding solid white;
                        box-sizing: border-box;
                    }

                    .number {
                        background: lighten($grey, 05%);
                        border-radius: 100%;
                        font-size: 0.75em;

                        width: $stepIconSize * 1.25;
                        height: $stepIconSize * 1.25;
                        line-height: $stepIconSize;
                    }

                    .name {
                        background: $grey;
                        border-radius: 2px;
                        padding: $innerPadding $innerPadding * 2;
                        position: relative;
                        box-shadow: none;

                        &:before {
                            content: '';
                            width: $innerPadding * 2;
                            height: $innerPadding * 2;
                            overflow: hidden;
                            background: $grey;
                            position: absolute;
                            top: 0;
                            left: 50%;
                            margin-left: -$innerPadding;
                            margin-top: -$innerPadding;
                            transform: rotate(45deg);
                        }

                        &:hover, &:focus {
                            color: black;
                        }
                    }
                }

                &.completed {
                    &:after {
                        background-color: $yellow;
                    }
                    .step-details {
                        > .number {
                            background-color: lighten($yellow, 5%);
                        }
                        > .name {
                            background-color: $yellow;

                            &:before {
                                background: $yellow;
                            }

                        }
                    }
                }

                &.completed {
                }

                &.active {
                    font-weight: bold;

                    .step-details {
                        > .number {
                            background-color: lighten($yellow, 5%);
                        }
                        > .name {
                            background-color: $yellow;

                            &:before {
                                background: $yellow;
                            }

                        }
                    }
                }
            }
        }
    }
</style>


<script>
    const ThrobberOverlay = require('./booking/ThrobberOverlay');

    const events = {};

    export default {
        components: {
            ThrobberOverlay,
        },
        props: {
            currentStep: {
                type: Number,
                required: true,
            },
            stepCount: {
                type: Number,
                required: true,
            },
            stepNames: {
                type: Array,
                required: false,
            },
            hrefs: {
                type: Array,
                required: false,
            },
        },
        data: () => {
            return {
                steps: [],
            }
        },
        computed: {},
        mounted() {
            for (let i = 0; i < this.stepCount; i++) {
                let step = i + 1;
                this.steps.push({
                    step: step,
                    name: this.$_getStepName(step),
                    href: this.$_getHref(step),
                    completed: step < this.currentStep,
                    active: step === this.currentStep,
                });
            }
        },
        methods: {
            /**
             * 1-based index
             * @param step
             * @returns {string}
             */
            $_getStepName: function (step) {
                let defaultName = `Step ${step}`;

                if (!this.stepNames) {
                    return defaultName;
                }

                step--;

                if (step < 0 || step >= this.stepNames.length || !this.stepNames[step]) {
                    return defaultName;
                }

                return this.stepNames[step];
            },
            /**
             * 1-based index
             * @param step
             * @returns {string}
             */
            $_getHref: function (step) {
                let defaultHref = '#';

                if (!this.hrefs) {
                    return defaultHref;
                }

                step--;

                if (step < 0 || step >= this.hrefs.length || !this.hrefs[step]) {
                    return defaultHref;
                }

                return this.hrefs[step];
            },
        }
    }
</script>
